import { lazy } from 'react'
import Layout from '../component/layouts/Layout'

const routes = [
    {
        path: '/',
        exact: true,
        name: 'Home',
        component: lazy(() => import('../container/homeCombo/HomeComboContainer')),
        layout: Layout
    },
    {
        path: '/home',
        exact: true,
        name: 'Home',
        component: lazy(() => import('../container/home/HomeContainer')),
        layout: Layout
    },
    {
        path: '/thanh-toan/step1/:id',
        exact: true,
        name: 'Check Out 1',
        component: lazy(() => import('../container/check-out-1/CheckOut1Container')),
        layout: Layout
    },
    {
        path: '/thanh-toan/step2/:br',
        exact: true,
        name: 'Check Out 2',
        component: lazy(() => import('../container/check-out-2/CheckOut2Container')),
        layout: Layout
    },
    {
        path: '/combo-detail',
        exact: true,
        name: 'Combo detail',
        component: lazy(() => import('../container/combo-detail/ComboDetailContainer')),
        layout: Layout
    },
    // {** flight **}
    {
        path: '/flight-list',
        exact: true,
        name: 'Select Flight Date',
        component: lazy(() => import('../container/flight/FlightListContainer')),
        layout: Layout
    },
    // thanh toán
    {
        path: '/thank-you/:paygate',
        exact: true,
        name: 'Check status order ',
        component: lazy(() => import('../container/thank-you/TransactionConfirmContainer')),
        layout: Layout,
    },
    {
        path: '/thanh-toan/that-bai',
        exact: true,
        name: 'Check status order ',
        component: lazy(() => import('../container/thanh-toan/PayFailed')),
        layout: Layout,
    },
    {
        path: '/thanh-toan/thanh-cong',
        exact: true,
        name: 'Check status order ',
        component: lazy(() => import('../container/thanh-toan/PaySuccess')),
        layout: Layout,
    },
    {
        path: '',
        exact: true,
        name: '404',
        component: lazy(() => import('../component/404/NotFound')),
        layout: Layout
    }
]
export default routes
